import {
    AUTO_SCROLL_MAX_SPEED,
    AUTO_SCROLL_ZONE,
    SCROLL_PADDING,
} from "@/interface/RightSheet/Presentations/PresentationsNavigator/constants";

const getScrollSpeed = (distance: number) => {
    const ratio = 1 - distance / AUTO_SCROLL_ZONE;
    return Math.max(2, ratio * AUTO_SCROLL_MAX_SPEED);
};

export const autoScrollOnDrag = (clientY: number, container: HTMLDivElement) => {
    if (!container) return;

    const rect = container.getBoundingClientRect();

    const topZoneStart = rect.top + SCROLL_PADDING;
    const bottomZoneStart = rect.bottom - SCROLL_PADDING;

    if (clientY < topZoneStart) {
        const distance = clientY - rect.top;
        container.scrollTop -= getScrollSpeed(distance);
    } else if (clientY > bottomZoneStart) {
        const distance = rect.bottom - clientY;
        container.scrollTop += getScrollSpeed(distance);
    }
};
